module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-37.d34420e8.png";